/*
 * newsbot - forked from autobrr
 */

import { ReactNode } from "react";

interface SectionProps {
  title: string;
  description: string;
  children: ReactNode;
}

export const Section = ({ title, description, children }: SectionProps) => (
  <div className="lg:col-span-9 px-4 py-6 sm:px-6 lg:py-8">
    <div className="mb-6">
      <h2 className="text-xl font-bold text-black dark:text-white">{title}</h2>
      <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{description}</p>
    </div>
    {children}
  </div>
);
